<template>
  <div>
    <div class="panel-heading">
      <h4 class="panel-title">{{ $t('orders.approvedExportOrdersTitle') }}</h4>
    </div>

    <div
      class="panel-body"
      style="display: block;"
    >
      <div class="row">
        <preDatatableComponent
          :removeAddButton="true"
          :removeWarehouseDeliverButton="true"
          :checkAlert="checkAlert"
          :tableData="tableData"
          :resetGetResults="resetGetResults"
          :searchMe="searchMe"
          :enableCustomerSearchSuggestions="true"
          :pagination="pagination"
          :perPageFix="perPageFix"
          :filterTable="filterTable"
          :resetGetResults2="resetGetResults2"
          :columns="columns"
          :showHideColumn="showHideColumn"
          :filterMade="filterMade"
          :totalResult="totalResult"
        ></preDatatableComponent>
        <div class="col-xs-12">
          <datatable
            :sortDir="tableData.sortDir"
            :columns="columns"
            :sortByColumn="sortByColumn"
            :searchOneCol="searchOneCol"
            :sortKey="sortKey"
            :sortOrders="sortOrders"
            :checkAll="checkAll"
            :unCheckAll="unCheckAll"
          >
            <tbody>
              <tr
                v-for="(r, index) in apiResults"
                :key="r.export_order_id"
                :style="selectedRows.find(x => x == r.export_order_id) ? 'background-color: #FFF9C4' : '' "
              >
                <td>
                  <input
                    :id="'cb' + index"
                    type="checkbox"
                    :value="[r.export_order_id]"
                    v-model="selectedRows"
                  />
                </td>
                <td>{{ r.order_number }}</td>
                <td class="ws-nowrap">
                  <span v-if="r.full_name && r.full_name.trim().split(/\s+/).length > 3" style="word-break: break-word; white-space: pre-line;">
                    {{ r.full_name.replace(/((?:\S+\s+){3})/g, '$1\n') }}
                  </span>
                  <span v-else>
                    {{ r.full_name }}
                  </span>
                  <open-whatsapp-and-viber :phoneNumber="r.phone_number" />
                </td>
                <td class="customer-note-color"> {{ r.customer_note }} </td>
                <td>{{ r.product_name }}</td>
                <td>{{ r.quantity }}</td>
                <td>{{ r.price | usdFormat }}</td>
                <td>{{ r.country_name }}</td>
                <td>{{ r.note }}</td>
                <td>{{ r.created_at | moment("YYYY-MM-DD hh:mm A") }}</td>
                <td
                  v-if="$_has_perm('view_export_order_detail')"
                  style="padding: 0px 5px"
                >
                  <a
                    style="color:#01579B"
                    :tooltip="$t('orders.viewDetails')"
                    @click="showDetail(r.export_order_id)"
                  >
                    <i class="material-icons">aspect_ratio</i>
                  </a>
                </td>
                <td
                  v-if="$_has_perm('send_export_order')"
                  style="padding: 0px 5px"
                >
                  <a
                    style="color:#4347a0"
                    :tooltip="$t('orders.sendTooltip')"
                    @click="send(r.export_order_id)"
                  >
                    <i
                      class="fa fa-plane"
                      style="font-size:20px"
                    ></i>
                  </a>
                </td>
                <td
                  v-if="$_has_perm('add_export_order_refund') && !r.is_fully_refunded"
                  style="padding: 0px 5px"
                >
                  <a
                    style="color:#ff9800"
                    :tooltip="$t('orders.partialRefundTooltip')"
                    @click="openRefundDialog(r.export_order_id, r.price, r.total_refunded_amount || 0, 'partial')"
                  >
                    <i class="fa fa-undo" style="font-size:18px"></i>
                  </a>
                </td>
                <td
                  v-if="$_has_perm('add_export_order_refund') && !r.is_fully_refunded"
                  style="padding: 0px 5px"
                >
                  <a
                    style="color:#d32f2f"
                    :tooltip="$t('orders.fullRefundTooltip')"
                    @click="openRefundDialog(r.export_order_id, r.price, r.total_refunded_amount || 0, 'full')"
                  >
                    <i class="fa fa-reply-all" style="font-size:18px"></i>
                  </a>
                </td>
                <!-- <td
                  v-if="$_has_perm('cancel_export_order')"
                  style="padding: 0px 5px"
                >
                  <a
                    @click="openCancelDialog(r.export_order_id)"
                    style="color:#C62828"
                    :tooltip="$t('orders.cancelTooltip')"
                  >
                    <i class="material-icons">cancel</i>
                  </a>
                </td> -->
              </tr>
              <tr id="no-result-row">
                <td
                  :colspan="columns.length"
                  class="text-center"
                >
                  <v-alert
                    type="error"
                    :value="alertValue"
                  >
                    {{ $t('common.noResultsFound') }}
                  </v-alert>
                </td>
              </tr>
            </tbody>
          </datatable>

          <view-export-order-details
            :instance="instance"
            :detailDialog="detailDialog"
            @close="detailDialog = false"
          />

          <cancel-export-order
            :cancelDialog="cancelDialog"
            :id="id"
            @close="cancelDialog = false"
            @update-table="getResults()"
          />

          <refund-export-order
            :refundDialog="refundDialog"
            :orderId="selectedOrderId"
            :refundType="selectedRefundType"
            :orderPrice="selectedOrderPrice"
            :alreadyRefunded="selectedAlreadyRefunded"
            @close="refundDialog = false"
            @refund-success="handleRefundSuccess"
          />

          <hr />
          <div class="row">
            <div class="col-xs-12 text-right">
              <pagination
                :page-count="pagination.lastPage"
                :page-range="2"
                :changePage="changePage"
                :container-class="'pagination'"
                :pagination="pagination"
                :page-class="'page-item'"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pagination from '../Pagination.vue'
import preDatatableComponent from '../preDatatableComponent.vue'
import datatable from '../Datatable.vue'
import axios from 'axios'
import swal from 'sweetalert'
import cancelExportOrder from './cancelExportOrder.vue'
import viewExportOrderDetails from './viewExportOrderDetails.vue'
import refundExportOrder from './refundExportOrder.vue'

export default {
  components: {
    preDatatableComponent,
    datatable,
    pagination,
    cancelExportOrder,
    viewExportOrderDetails,
    refundExportOrder
  },

  mounted() {
    this.perPageFix()
  },

  $_veeValidate: {
    validator: 'new'
  },

  data() {
    let sortOrders = {}
    let columns = [
      { label: '', name: '', text: this.$t('columns.checkBoxColumn'), value: '1' },
      {
        label: this.$t('columns.orderId'),
        text: this.$t('columns.orderId'),
        value: '2',
        sortable: true,
        searchable: true,
        name: 'order_number'
      },
      {
        label: this.$t('columns.customerName'),
        text: this.$t('columns.customerName'),
        value: '3',
        sortable: true,
        searchable: true,
        name: 'full_name'
      },
      {
        label: this.$t('columns.customerNote'),
        text: this.$t('columns.customerNote'),
        value: '4',
        sortable: true,
        searchable: true,
        name: 'customer_note'
      },
      {
        label: this.$t('columns.productName'),
        text: this.$t('columns.productName'),
        value: '5',
        sortable: true,
        searchable: true,
        name: 'product_name'
      },
      {
        label: this.$t('columns.quantity'),
        text: this.$t('columns.quantity'),
        value: '6',
        sortable: true,
        searchable: true,
        name: 'quantity'
      },
      {
        label: this.$t('columns.price'),
        text: this.$t('columns.price'),
        value: '7',
        sortable: true,
        searchable: true,
        name: 'price'
      },
      {
        label: this.$t('columns.country'),
        text: this.$t('columns.country'),
        value: '8',
        sortable: true,
        searchable: true,
        name: 'country_name'
      },
      {
        label: this.$t('columns.note'),
        text: this.$t('columns.note'),
        value: '9',
        sortable: true,
        searchable: true,
        name: 'note'
      },
      {
        label: this.$t('common.date'),
        text: this.$t('common.date'),
        value: '10',
        sortable: true,
        searchable: true,
        name: 'created_at'
      }
    ]
    columns.forEach((column) => {
      sortOrders[column.name] = -1
    })

    return {
      url: 'api/export-order/approved',
      selectedRows: [],
      id: 0,
      filterMade: false,
      totalResult: 0,
      alertValue: false,
      checkAlert: false,
      detailDialog: false,
      cancelDialog: false,
      refundDialog: false,
      selectedOrderId: 0,
      selectedRefundType: 'partial',
      selectedOrderPrice: 0,
      selectedAlreadyRefunded: 0,
      instance: {
        customer: {},
        to_country: {}
      },
      prevSearchQuery: '',
      apiResults: [],
      columns: columns,
      sortKey: 'export_order_id',
      sortOrders: sortOrders,
      tableData: {
        per_page: 10,
        search: '',
        column: 'export_order_id',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: '',
        branches_id: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    }
  },

  methods: {
    showHideColumn(prevColVal, currentColVal) {
      let a = []
      let diff = []

      if (currentColVal.length < prevColVal.length) {
        for (let i = 0; i < prevColVal.length; i++) {
          a[prevColVal[i]] = true
        }

        for (let i = 0; i < currentColVal.length; i++) {
          if (a[currentColVal[i]]) {
            delete a[currentColVal[i]]
          } else {
            a[currentColVal[i]] = true
          }
        }

        for (let k in a) {
          diff.push(k)
        }

        for (let c = 0; c < diff.length; c++) {
          $('td:nth-child(' + diff[c] + '),th:nth-child(' + diff[c] + ')').toggle()
        }
      } else {
        for (let i = 0; i < currentColVal.length; i++) {
          let visible = $(
            'td:nth-child(' + currentColVal[i] + '),th:nth-child(' + currentColVal[i] + ')'
          ).is(':visible')
          if (visible) {
            $(
              'td:nth-child(' + currentColVal[i] + '),th:nth-child(' + currentColVal[i] + ')'
            ).toggle()
          }
        }
      }
    },

    resetGetResults2() {
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      this.tableData.search = ''
      this.sortKey = 'updated_at'
      this.tableData.sortDir = 'desc'
      this.tableData.column = 'updated_at'
      this.tableData.from_date = ''
      this.tableData.to_date = ''
      this.getResults()
    },

    send(id) {
      swal({
        title: this.$t('common.areYouSure'),
        text: '',
        icon: 'warning',
        buttons: true
      }).then((approved) => {
        if (approved) {
          let token = localStorage.getItem('access_token')
          axios
            .get(`api/export-order/${id}/send`, {
              headers: { Authorization: 'Bearer ' + token }
            })
            .then(() => {
              this.getResults()
              swal({
                title: this.$t('orders.sentStatusTitle'),
                text: '',
                icon: 'success',
                timer: 1500,
                buttons: false
              })
            }).catch((error) => {
              swal(this.$t('common.error'), error.response.data.message, 'error')
            })
        }
      })
    },

    openCancelDialog(id) {
      this.cancelDialog = true
      this.id = id
    },

    openRefundDialog(orderId, price, alreadyRefunded, refundType) {
      this.selectedOrderId = orderId
      this.selectedOrderPrice = parseFloat(price) || 0
      this.selectedAlreadyRefunded = parseFloat(alreadyRefunded) || 0
      this.selectedRefundType = refundType
      this.refundDialog = true
    },

    handleRefundSuccess() {
      this.refundDialog = false
      this.getResults()
    },

    getResults(url = this.url) {
      var token = localStorage.getItem('access_token')
      let theDatatable = document.querySelector('.the-datatable')
      let thePanel = document.querySelector('.panel-flat')

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out')
        thePanel.style.overflowX = 'auto'
      }

      axios
        .get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          let data = response.data
          const isFlatArray = Array.isArray(data.data)
          if (isFlatArray) {
            this.filterMade = true
            this.apiResults = data.data
          } else {
            this.filterMade = false
            this.apiResults = data.data.data
          }

          if (this.apiResults.length === 0) {
            this.tableData.searchOneCol = ''
            this.tableData.searchOneVal = ''
            this.tableData.search = ''
            this.alertValue = true
          } else {
            this.alertValue = false
          }
          if (isFlatArray) {
            this.removeConfigPagination()
          } else {
            this.configPagination(data.data)
          }
          theDatatable.classList.remove('slide-table-out')
          setTimeout(function () {
            thePanel.style.overflowX = 'auto'
          }, 0)
        })
        .then(() => {
          this.totalResult = 0
          for (let i = 0; i < this.apiResults.length; i++) {
            this.totalResult += 1
          }
        })
        .catch((errors) => { })
    },

    resetGetResults() {
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      this.tableData.search = ''
      this.sortKey = 'updated_at'
      this.tableData.sortDir = 'desc'
      this.tableData.column = 'updated_at'
      this.tableData.from_date = ''
      this.tableData.to_date = ''
      this.getResults()
    },

    perPageFix(perPage) {
      this.tableData.per_page = perPage
      this.getResults()
    },

    calculateTotalAmount() {
      let itemPrice = Number(this.updateData.item_price) || 0
      let shipping = Number(this.updateData.internal_shipping_handling) || 0
      let tax = Number(this.updateData.tax) || 0
      let nationalTax = Number(this.updateData.national_tax) || 0
      let delivery = Number(this.updateData.delivery_price) || 0
      let fee = Number(this.updateData.kreenex_fee) || 0
      let insurance = Number(this.updateData.insurance) || 0
      let qttCharge = Number(this.updateData.quantity_charge) || 0
      let discount = Number(this.updateData.discount) || 0
      let qtt = Number(this.theQuantity.quantity) || 0

      let total =
        itemPrice * qtt + shipping + tax + nationalTax + delivery + fee + insurance + qttCharge

      if (discount > 0) {
        total -= discount
      }

      this.updateData.total_amount = total.toFixed(2)
    },

    changePage(pageUrl) {
      this.url = pageUrl
      this.getResults()
    },

    showDetail(id) {
      let token = localStorage.getItem('access_token')

      axios
        .get(`api/export-order/${id}`, { headers: { Authorization: 'Bearer ' + token } })
        .then((res) => {
          this.detailDialog = true
          this.instance = res.data.data
        })
    },

    searchMe(str) {
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      if (str.trim() !== '') {
        this.tableData.search = str
        this.prevSearchQuery = str
        this.getResults()
      } else {
        swal({
          text: this.$t('common.typeToSearch'),
          icon: 'warning',
          dangerMode: true
        })
        if (this.prevSearchQuery !== '') {
          this.tableData.search = ''
          this.prevSearchQuery = ''
          this.getResults()
        }
      }
    },

    sortByColumn(str) {
      this.tableData.column = str
      this.tableData.sortKey = str
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc'
      this.getResults()
    },

    searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName
      this.tableData.searchOneVal = str
      this.getResults()
    },

    filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate
      this.tableData.to_date = toDate
      this.getResults()
    },

    configPagination(data) {
      this.pagination.lastPage = data.last_page
      this.pagination.currentPage = data.current_page
      this.pagination.total = data.total
      this.pagination.lastPageUrl = data.last_page_url
      this.pagination.nextPageUrl = data.next_page_url
      this.pagination.prevPageUrl = data.prev_page_url
      this.pagination.from = data.from
      this.pagination.to = data.to
    },

    removeConfigPagination() {
      this.pagination.lastPage = ''
      this.pagination.currentPage = ''
      this.pagination.total = ''
      this.pagination.lastPageUrl = ''
      this.pagination.nextPageUrl = ''
      this.pagination.prevPageUrl = ''
      this.pagination.from = ''
      this.pagination.to = ''
    },

    checkAll() {
      for (let i = 0; i < this.apiResults.length; i++) {
        if (!$('#cb' + i).is(':checked')) {
          $('#cb' + i).click()
        }
      }
    },

    unCheckAll() {
      for (let i = 0; i < this.apiResults.length; i++) {
        if ($('#cb' + i).is(':checked')) {
          $('#cb' + i).click()
        }
      }
    }
  }
}
</script>

<style>
@media screen and (max-width: 600px) {
  th {
    font-weight: bold;
    color: #273246;
    padding-left: 5px !important;
  }

  td {
    padding-left: 5px !important;
    padding-top: 10px !important;
    padding-bottom: 10px !important;
  }
}

.panel-heading h4 {
  text-transform: uppercase;
  margin-left: -20px;
  padding-left: 10px;
  font-weight: 500;
}

.icon-enlarge,
.icon-pencil {
  color: navy;
}

.icon-bin2 {
  color: red;
}

.icon-calendar {
  color: green;
}

.btn {
  transition: all 0.5s;
}

.col-xs-12 {
  padding-top: 10px;
  padding-bottom: 10px;
}
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}

.dialog {
  box-shadow: 0 3px 5px -1px rgba(14, 14, 14, 0.212) !important;
  overflow: hidden !important;
  overflow-y: auto !important;
}
.page-stats {
  align-items: center;
  position: relative;
  top: -8px;
  margin-right: 5px;
}

.dialog:not(.dialog--fullscreen) {
  max-height: 95%;
}

@media screen and (max-width: 767px) {
  .form-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}

a:hover {
  color: #03a9f4;
  position: relative;
}
a[tooltip]:hover:after {
  content: attr(tooltip);
  padding: 8px 12px;
  color: #ffffff;
  position: absolute;
  right: 80%;
  bottom: 150%;
  white-space: nowrap;
  z-index: 20;
  -moz-border-radius: 3px;
  -webkit-border-radius: 3px;
  border-radius: 3px;
  -moz-box-shadow: 0px 0px 2px #484b4e;
  -webkit-box-shadow: 0px 0px 2px #484b4e;
  box-shadow: 0px 0px 2px #484b4e;
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -webkit-gradient(
    linear,
    left top,
    left bottom,
    color-stop(0, #484b4e),
    color-stop(1, #484b4e)
  );
  background-image: -webkit-linear-gradient(top, #484b4e, #484b4e);
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -ms-linear-gradient(top, #484b4e, #484b4e);
  background-image: -o-linear-gradient(top, #484b4e, #484b4e);
}
</style>



// WEBPACK FOOTER //
// src/components/exportOrder/approvedExportOrder.vue